import { safeLocalStorage } from '@ifixit/utils';

export const META_UTM_CAMPAIGN_KEY = 'meta_utm_campaign';

export function storeMetaCampaign(url: URL) {
   const utmCampaign = url.searchParams.get('utm_campaign');
   if (!hasMetaSource(url) || utmCampaign == null) {
      return;
   }
   safeLocalStorage.setItem(META_UTM_CAMPAIGN_KEY, utmCampaign);
}

function hasMetaSource(url: URL): boolean {
   const utmSource = url.searchParams.get('utm_source');
   const utmMedium = url.searchParams.get('utm_medium');
   return utmSource?.toLowerCase() === 'facebook' && utmMedium?.toLowerCase() === 'paid';
}
